export default __webpack_public_path__ + "static/media/Icons-MakeMoney.90baedd3.svg";